import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectMembershipMemberMappingsListItems } from "../../../../../../redux/membership-member-mappings/selector";
import { membershipMemberMappings } from "../../../../../../redux/membership-member-mappings/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementMembershipMemberMappings = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const membershipMemberMappingItems = useSelector(selectMembershipMemberMappingsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'MembershipName', headerName: 'Membership Name'  },
          { field: 'MembershipTypeName', headerName: 'MembershipType Name' },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true }
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      const handleDelete=(data: any)=>{
        dispatch(membershipMemberMappings.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings/delete`,
          entity: 'membershipMemberMappings',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
        dispatch(membershipMemberMappings.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings/list`,entity:'membershipMemberMappings',jsonData:{
           "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }  
      const fetchMembershipMemberMappings=()=>{

        dispatch(membershipMemberMappings.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/membership-member-mappings/list`,entity:'membershipMemberMappings',jsonData:{
           "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc"}
          }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchMembershipMemberMappings()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add MembershipMemberMappings',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
         {membershipMemberMappingItems?.isLoading ? 
    <PageLoader />
: 
		<Table columnData={columnDefs} rowData={membershipMemberMappingItems?.result?.items} setPageData={setPageData}
    paginationData={membershipMemberMappingItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Membership Member Mapping" />
  }
  </> 
     
	);
};

export default ManagementMembershipMemberMappings;


